import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import {
  StaffInvitePage,
  areStaffInviteSearchEqual,
  normalizeStaffInviteSearch,
  staffInviteSearchSchema,
} from '@/features/staff';

export const Route = createFileRoute('/_authed/staff/new')({
  validateSearch: zodValidator(staffInviteSearchSchema),
  beforeLoad: ({ search }) => {
    const normalizedSearch = normalizeStaffInviteSearch(search);

    if (!areStaffInviteSearchEqual(search, normalizedSearch)) {
      throw redirect({
        to: '/staff/new',
        search: normalizedSearch,
        replace: true,
      });
    }
  },
  component: StaffNewRouteComponent,
});

function StaffNewRouteComponent() {
  const search = Route.useSearch();
  return <StaffInvitePage assignmentId={search.assignment_id} />;
}
